import { useSearchParams } from "react-router-dom";

import { useCompleteLogin, useInitLogin } from "apps-common/hooks/AccountApi";
import { throwError } from "apps-common/utils/errorHandler";
import { Loader } from "ui";

interface LoginFormProps {
  onLogin: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MoiLogin = ({ onLogin }: LoginFormProps) => {
  const [searchParams] = useSearchParams();

  const error = searchParams.get("error") ?? undefined;

  if (error) {
    throw throwError("signupUnknown", error);
  }

  const redirectUri = window.location.href.split("?")[0];
  const state = searchParams.get("state") ?? "";
  const code = searchParams.get("code") ?? "";

  const {
    data: initData,
    error: errorFetching,
    isFetching: isFetching,
  } = useInitLogin(redirectUri, !(state && code));

  if (errorFetching) {
    throw throwError("signupUnknown", errorFetching);
  }

  const {
    data: endLoginData,
    error: errorFetchingEnd,
    isFetching: isFetchingLoginEnd,
  } = useCompleteLogin(redirectUri, code, state, state !== "" && code !== "");

  if (errorFetchingEnd) {
    throw throwError("signupUnknown", errorFetchingEnd);
  }

  if (isFetching || isFetchingLoginEnd) {
    return <Loader />;
  }

  if (initData?.authorizationRequestUrl) {
    window.location.href = initData.authorizationRequestUrl;
  }

  if (endLoginData) {
    onLogin();
    window.location.href = "/";
  }

  return null;
};

export default MoiLogin;
